'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Column;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _MatchTooltip = require('shared/components/MatchTooltip');

var _MatchTooltip2 = _interopRequireDefault(_MatchTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPointer = function getPointer(end, fullSlug) {
  if (end.fullSlug !== fullSlug) {
    return _react2.default.createElement('div', { className: 'pointer' });
  }

  return null;
};

var getImage = function getImage(image) {
  if (image && image.url) {
    return _react2.default.createElement('img', { src: image.url, alt: image.title });
  }

  return null;
};

function Column(_ref) {
  var isActive = _ref.isActive,
      match = _ref.match,
      title = _ref.title,
      description = _ref.description,
      subsector = _ref.subsector,
      fullSlug = _ref.fullSlug,
      end = _ref.end,
      image = _ref.image;

  var roleClass = ['role', isActive ? 'active' : null].join(' ');

  //const jobMapImage = require('shared/images/stock/shutterstock01-small.png');

  return _react2.default.createElement(
    'div',
    { className: 'column' },
    getPointer(end, fullSlug),
    _react2.default.createElement(
      'div',
      { className: 'role-col' },
      _react2.default.createElement(
        'div',
        { className: roleClass },
        _react2.default.createElement(_MatchTooltip2.default, {
          match: match,
          matchMeComponent: function matchMeComponent() {
            return _react2.default.createElement(
              'div',
              { className: 'role-percent no-match c-tooltip down' },
              _react2.default.createElement(
                'span',
                null,
                'Match'
              ),
              _react2.default.createElement(
                'em',
                null,
                'me'
              )
            );
          },
          matchComponent: function matchComponent(parsedMatch) {
            return _react2.default.createElement(
              'div',
              { className: 'role-percent c-tooltip down' },
              _react2.default.createElement(
                'em',
                null,
                parsedMatch
              ),
              _react2.default.createElement(
                'span',
                null,
                'Match'
              )
            );
          }
        }),
        _react2.default.createElement(
          'p',
          { className: 'role-title' },
          subsector,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: fullSlug },
            title
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'role-info' },
        _react2.default.createElement('div', { className: 'connector' }),
        _react2.default.createElement(
          'div',
          { className: 'role-info-img' },
          getImage(image)
        ),
        _react2.default.createElement('p', {
          dangerouslySetInnerHTML: {
            __html: (description || '').substring(0, 100)
          }
        })
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/PopularPath/components/Column.jsx
// module id = 1251
// module chunks = 0